import React from 'react';
import { useTranslation } from 'react-i18next';

import { TActivateTenantProps } from '@/backoffice/features/tenants/components/activate-tenant/activate-tenant.types';
import { useActivateTenantMutation } from '@/backoffice/redux/api/backoffice/backoffice-api';
import { TenantIcon } from '@/shared/assets/icons/tenant-icon';
import { ConfirmDialog } from '@/shared/components/ui/confirm-dialog/confirm-dialog';
import { MenuItem } from '@/shared/components/ui/menu-item/menu-item';

export const ActivateTenant: React.FC<TActivateTenantProps> = ({
  onSuccess,
  disabled,
  tenantId,
}) => {
  const { t } = useTranslation();
  const [activateTenant] = useActivateTenantMutation();

  const handleActivateTenant = async () => {
    await activateTenant({ tenantId }).unwrap();
  };

  return (
    <ConfirmDialog
      mutation={handleActivateTenant}
      headline={t('backoffice:activate_tenant_confirmation_title')}
      triggerComponent={
        <MenuItem disabled={disabled || !tenantId} icon={<TenantIcon />}>
          {t('backoffice:activate_tenant')}
        </MenuItem>
      }
      onSuccess={onSuccess}
      successMessage={t('backoffice:tenant_activated_successfully')}
      errorMessage={t('backoffice:tenant_activation_failed')}
      primaryButtonLabel={t('common:activate')}
    />
  );
};
